// defines the order of options in the UI
export const FILTER_OPTIONS = [
  "in-dashboard",
  "not-in-personal-collection",
] as const;

// defines the order of options in the UI
export const SORT_COLUMNS = ["view-count", "name", "location"] as const;
